import { ReactNode } from "react";
import {
  getVerificationTitleName,
  isIncomeVerificationSkipped,
  verificationSourceType
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils";
import { Logo } from "../../components/Logo";
import { CombinedIncome } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { VerifiedItem } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified";

export const VerifiedHeader = ({
  currentItem,
  income
}: {
  currentItem?: VerifiedItem | VerifiedItem[];
  income: CombinedIncome;
  onReverify?: () => void;
  reverifyDisabled?: boolean;
  reverifyTooltip?: ReactNode;
}) => {
  const isGroupedItems = Array.isArray(currentItem);
  const isVerificationSkipped = isIncomeVerificationSkipped(income);
  let logo, incomeSourceType;

  if (!currentItem) {
    logo = "";
    incomeSourceType = income.verified_source_type;
  } else if (isGroupedItems) {
    logo = "";
    incomeSourceType = currentItem[0].income_source_type;
  } else {
    logo =
      (currentItem.data &&
        "institution_metadata" in currentItem.data &&
        currentItem.data.institution_metadata?.logo) ||
      "";
    incomeSourceType = currentItem.income_source_type;
  }

  return (
    <div className="flex justify-between mb-4">
      <div className="flex gap-4 items-center">
        <Logo logo={logo} verified_source_type={incomeSourceType} />
        <div>
          <h2 className="text-base text-content-1000 font-medium mb-1">
            {isVerificationSkipped
              ? "Income verification was not available"
              : getVerificationTitleName(income)}
          </h2>
          <p className="text-sm text-content-400">
            {isVerificationSkipped
              ? "—"
              : verificationSourceType[incomeSourceType || ""] ||
                incomeSourceType}
          </p>
        </div>
      </div>
    </div>
  );
};
